import { useNavigate } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { ScheduleCalendar } from "@/components/ScheduleCalendar";
import { useI18n } from "@/i18n/I18nContext";
import { Seo } from "@/components/Seo";

const SCHEDULE_CRUMBS = [{ name: "Horario", path: "/schedule" }];

export default function PublicSchedule() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <PublicLayout>
      <Seo
        title="Horario de clases — Gym Frenchies Fitness & Pilates Coronado"
        description="Horario semanal de clases de fitness, functional movement, y Pilates Reformer en Coronado, Panamá. Reserva tu clase en línea."
        path="/schedule"
        keywords="horario clases Coronado, horario gym Coronado, reservar clase fitness Coronado, horario Pilates Coronado"
        breadcrumbs={SCHEDULE_CRUMBS}
      />
      <section className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <h1 className="mb-8 font-display text-4xl font-bold tracking-tight sm:text-5xl">{t("schedule.title")}</h1>
        <ScheduleCalendar onBook={() => navigate("/login")} onWaitlist={() => navigate("/login")} />
      </section>
    </PublicLayout>
  );
}
